import Typography from '@mui/material/Typography';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import Prompt from '../../Prompt/Prompt';

import {
  TXTSRV_You_are_currently_unable_to_ch_ELL,
  TXTWCL_Okay,
  TXTWCL_There_has_been_an_issue_with_y_ELL
} from './UserHasPendingCashoutError.messages.json';

interface Props {
  onClose(): void;
}

const UserHasPendingCashoutError: React.FC<Props> = ({ onClose }) => (
  <Prompt
    variant="error"
    title={{ translation: TXTWCL_There_has_been_an_issue_with_y_ELL }}
    primaryButton={{ translation: TXTWCL_Okay }}
    onClose={onClose}
  >
    <Typography>
      <Translation {...TXTSRV_You_are_currently_unable_to_ch_ELL} />
    </Typography>
  </Prompt>
);

export default UserHasPendingCashoutError;
